<template>
  <div :id="echartId" :style="styles"></div>
</template>

<script>
import echarts from 'echarts'
export default {
  data () {
    return {
      echartsDom: {}
    }
  },
  mounted () {
    setTimeout(() => {
      this.initCharts()
    }, 500)
  },
  props: {
    styles: {
      type: Object,
      default: () => ({
        width: '100%',
        height: '500px'
      })
    },
    echartId: {
      type: String,
      default: 'charts-box'
    },
    options: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    options: {
      handler (newVal) {
        this.initCharts(newVal)
      },
      deep: true
    }
  },
  methods: {
    // 初始化echarts
    initCharts () {
      this.echartsDom = echarts.init(document.getElementById(this.echartId))
      this.echartsDom.setOption(this.options)
    },
    reSetCharts () {
      if (this.echartsDom) {
        this.echartsDom.setOption(this.options)
        this.echartsDom.on('mouseover', function (params) {
          if (params.componentType === 'markPoint') {
            return params
          }
        })
      }
    }
  }
}
</script>
